/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-tag-spacing */
import React from 'react';
import PropTypes from 'prop-types';

const visuallyHidden = {
  position: 'absolute',
  height: 1,
  width: 1,
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap'
};

const Checkmark = ({ title, width, height, ...rest }) => (
  <>
    <svg
      aria-hidden="true"
      focusable="false"
      height={height}
      preserveAspectRatio="none"
      viewBox="0 0 24 24"
      width={width}
      {...rest}
    >
      <path transform="scale(1 1)" d="M18 9.056l-7.293 7.293a1 1 0 0 1-1.414 0l-3.005-3.005c-.264-.549-.234-.997.09-1.344.324-.347.752-.41 1.284-.186L10 14.184l6.714-6.72c.478-.226.907-.147 1.286.238s.379.836 0 1.354z" fillRule="evenodd" />
    </svg>
    { title && <span style={visuallyHidden}>{title}</span>}
  </>
);

Checkmark.displayName = "Checkmark"

Checkmark.defaultProps = {
  height: 24,
  title: null,
  width: 24,
};

Checkmark.propTypes = {
  height: PropTypes.number,
  title: PropTypes.string,
  width: PropTypes.number,
};

export default Checkmark;
